module.exports = __webpack_public_path__ + "static/9-632401d2dbaceddd23fe838cfdbb8ec5.jpg";